import { apiClient } from './api-client';
import { ApiResponse, Grade, ListGradesResponse } from '../types';

export const GradeService = {
  /**
   * Get all grades
   * @returns Promise that resolves to an array of Grade objects
   */
  async getAllGrades(): Promise<Grade[]> {
    const response = await apiClient.get<ApiResponse<ListGradesResponse>>('/grades');
    return response.data.data.grades;
  },
  
  /**
   * Get a grade by ID
   * @param id The ID of the grade to retrieve
   * @returns Promise that resolves to a Grade object
   */
  async getGradeById(id: number): Promise<Grade> {
    const response = await apiClient.get<ApiResponse<Grade>>(`/grades/${id}`);
    return response.data.data;
  }
};